import { Model, go } from 'oderon-vue'

// import { delay } from 'oderon-commons/src/utils.js'

// export const CANConfigSet = new Model('/can-config-sets')
// CANConfigSet.getHex = (id) => go.get(`/can-config-sets/${id}/hex`)

export const CANDict = new Model('/can-dicts')

CANDict.getVariable = (canDictId, variableId) =>
  go.get(`/can-dicts/${canDictId}/variables/${variableId}`)

CANDict.patch = (canDictId, body) => go.patch(`/can-dicts/${canDictId}`, body)

CANDict.updateVariable = (canDictId, variableId, body) =>
  go.put(`/can-dicts/${canDictId}/variables/${variableId}`, body)

CANDict.createVariable = (canDictId, body) =>
  go.post(`/can-dicts/${canDictId}/variables`, body)

CANDict.duplicate = ({ sourceId, newName }) =>
  go.post(`/can-dicts/${sourceId}/duplicate`, { newName })
